export const FORM_SAVING_START = "form_saving_start";
export const FORM_SAVING_DONE = "form_saving_done";

export const FORM_REQUEST_CSRF_TOKEN = "form_request_csrf_token";
